import { useEffect, useRef } from 'react';
import type { LevelDoc } from '../model/format.ts';
import { netPlayOptions } from '../lobby/client.ts';
import { startPlay } from '../play/index.ts';

export function PlayView({ doc, spawn, onExit }: { doc: LevelDoc; spawn?: [number, number]; onExit: () => void }) {
  const ref = useRef<HTMLCanvasElement>(null);
  useEffect(() => {
    const session = startPlay({ canvas: ref.current!, doc, spawn, onExit, net: netPlayOptions() });
    return () => session.stop();
  }, [doc, spawn, onExit]);
  return <canvas ref={ref} className="play-canvas" tabIndex={0} />;
}
